import { Component, inject, input, model } from '@angular/core';
import { BackEndService } from 'src/app/services/backend.service';

@Component({
  selector: 'acknowledge-feedback',
  imports: [],
  templateUrl: './acknowledge-feedback.component.html',
  styleUrl: './acknowledge-feedback.component.scss'
})
export class AcknowledgeFeedbackComponent {

  historyID = input<number>(0, { alias: 'historyid' }) // The ID of the chat history
  acknowledged = model<string>('no', { alias: 'acknowledged' }) // 'positive' or 'negative'

  private backend = inject(BackEndService) // Inject the backend service

  sendAcknowledged() {
    // Logic to send acknowledgment to the backend
    if (this.acknowledged() === 'yes') {
      console.warn('Acknowledgment already sent for history ID:', this.historyID());
      return; // Prevent sending if already acknowledged
    }
    this.acknowledged.set('yes'); // Set acknowledged to 'yes'
    // Here you would typically call a service to send this acknowledgment to the backend
    console.log(`Acknowledgment for history ID ${this.historyID()} sent with status: ${this.acknowledged()}`);
    this.backend.ackChatHistoryFeedback(this.historyID())
      .subscribe({
        next: () => {
          console.log(`Acknowledgment for history ID ${this.historyID()} successfully sent.`);
        }
        , error: (err) => {
          console.error(`Failed to send acknowledgment for history ID ${this.historyID()}:`, err);
        }
      });
  }
}
